import { Flex } from "@zenchef/styled-system/jsx";
import {
  aromaDayButton,
  AromaDayButtonVariantProps,
} from "@zenchef/styled-system/recipes";
import { Text } from "../../typography/Text";

interface Props extends AromaDayButtonVariantProps {
  day: number;
}

export default function DayButton({ day, ...propsWithVariants }: Props) {
  const [variants, props] = aromaDayButton.splitVariantProps(propsWithVariants);
  const className = aromaDayButton(variants);

  return (
    <Flex className={className} {...props}>
      <Text textStyle="paragraph.m.bold">{day}</Text>
    </Flex>
  );
}
